/**
 * What counts as a "department" for transferDepartments / requestedDepartments extraction
 * (meta summaries, SMS handoff trigger). Keep in sync wherever this string is used.
 */
export const ROUTING_DEPARTMENTS_SCOPE = 'Departments include staff roles (such as leasing, maintenance, accounting, property management, sales, etc.) as well as asset management types (such as HOA, association, apartment, hotel, vacation rental, short-term rental, STR, hostel, self storage, commercial, etc.).';
//# sourceMappingURL=routing-departments-scope.js.map